import MedboxLogo from '@/assets/icons/medbox-footer-logo.svg';
import PrivacyChoices from '@/assets/images/privacy-choices.svg';
import FooterLink from './footer-link';
import AccreditedLogos from './icons-accreditation';

const col2 = [
    { label: 'Notice of Privacy Practices', link: 'https://medbox.com/notice-of-privacy-practices/' },
    { label: 'Child Safety Waiver', link: 'https://medbox.com/child-safety-waiver/' },
];

const col1 = [
    { label: 'Privacy Policy', link: 'https://medbox.com/privacy-policy/' },
    { label: 'Terms of Use', link: 'https://medbox.com/terms-of-use/' },
    { label: 'Cookie Policy', link: 'https://medbox.com/cookie-policy/' },
    { label: 'Privacy Choices', link: 'https://medbox.com/your-privacy-choices/', external: true, customClass: 'cky-banner-element', img: PrivacyChoices },
]

const fullLinkList = [
    { label: 'Privacy Policy', link: 'https://medbox.com/privacy-policy/' },
    { label: 'Terms of Use', link: 'https://medbox.com/terms-of-use/' },
    { label: 'Cookie Policy', link: 'https://medbox.com/cookie-policy/' },
    { label: 'Notice of Privacy Practices', link: 'https://medbox.com/notice-of-privacy-practices/' },
    { label: 'Child Safety Waiver', link: 'https://medbox.com/child-safety-waiver/' },
    { label: 'Privacy Choices', link: 'https://medbox.com/your-privacy-choices/', external: true, customClass: 'cky-banner-element', img: PrivacyChoices },
]

const Footer = () => {
    return (
        <footer className="h-full w-full font-atkinsonHyperlegible text-sm text-mint-400 relative">
            {/* Mobile wave */}
            <svg
                className="footer-wave block -scale-x-100 translate-y-[5px] leading-none md:hidden"
                viewBox="0 0 1440 90"
                preserveAspectRatio="none"
                aria-hidden="true"
            >
                <path
                    d="M0,40 C240,10 480,10 720,35 C960,60 1200,65 1440,35 L1440,120 L0,120 Z"
                    fill="#003D33"
                />
            </svg>

            {/* Desktop wave */}
            <svg
                className="absolute left-0 top-0 hidden w-full -translate-y-[95%] md:block z-100"
                viewBox="0 0 1440 55"
                preserveAspectRatio="none"
                aria-hidden="true"
            >
                <path fill="#003D33" d="M0,36 C180,46 360,52 540,44 C720,36 900,22 1080,18 C1240,14 1340,16 1440,20 L1440,120 L0,120 Z" />
            </svg>
            <div className='bg-primary-800 h-full'>
                <div className='hidden lg:flex flex-row justify-between pt-[30px] px-[90px] pb-[90px]'>
                    <div className='flex flex-col gap-[72px] mt-auto'>
                        <img className="w-[178px] h-[50px]" src={MedboxLogo} alt="MedBox logo" />
                        <div className="grid grid-cols-2 gap-[64px]">
                            <div className="flex flex-col space-y-4">
                                {col1.map(link => <FooterLink key={link.label} link={link} />)}
                            </div>

                            <div className="flex flex-col space-y-4">
                                {col2.map(link => <FooterLink key={link.label} link={link} />)}
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-col items-end max-w-[350px] max-w-[50%] xl:max-w-[580px]'>
                        <AccreditedLogos />
                        <div className='flex flex-col gap-[12px] text-right mt-[48px] font-atkinsonHyperlegible font-normal text-mint-400 leading-[140%]'>
                            <span className='block text-16'>
                                MedBox is an AmeriPharma company. AmeriPharma's long-term care pharmacy <br className='sm:hidden' /> services at home are available in 45+ states throughout the US.
                            </span>
                            <span className='block text-18'>
                                © 2026 MedBox by AmeriPharma. All Rights Reserved.
                            </span>
                        </div>
                    </div>
                </div>

                <div className='flex flex-col items-center lg:hidden pb-[110px] pt-[50px] px-[20px]'>
                    <div className='flex flex-col items-center gap-[56px]'>
                        <div className='flex flex-col items-center gap-[48px]'>
                            <div className='flex flex-col gap-[40px] items-center'>
                                <img className="w-[178px] h-[50px]" src={MedboxLogo} alt="MedBox logo" />
                                <AccreditedLogos />
                            </div>
                            <div className='flex flex-col gap-[12px] items-center'>
                                {fullLinkList.map(link => (
                                    <FooterLink key={link.label} link={link} />
                                ))}
                            </div>
                        </div>
                        <div className='flex flex-col mt-auto gap-[56px] text-center max-w-[350px] font-atkinsonHyperlegible font-normal text-mint-400 leading-[140%] text-18'>
                            <span className='block'>
                                MedBox is an AmeriPharma company. AmeriPharma's long-term care pharmacy services at home are available in 45+ states throughout the US.
                            </span>
                            <span className='block'>
                                © 2026 MedBox by AmeriPharma.<br /> All Rights Reserved.
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default Footer;
